module.exports = __webpack_public_path__ + "static/goals_rocket_plans_art-9d1809a48d9a0f054d632588bc0a356c.png";